var module = 'main', name = 'main/assets/svg/virtual-icons/person-full.svg', content = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.1042 18.112C17.7872 18.112 19.4702 17.33 20.7362 16.146C23.8872 13.196 24.9382 8.067 23.0522 4.335C21.7862 1.575 19.2672 0 16.1042 0C12.9522 0 10.2192 1.575 8.9532 4.335C7.0552 7.877 8.1182 13.196 11.2692 16.146C12.7382 17.33 14.2062 18.112 16.1042 18.112ZM16 20.8519C6.052 20.8519 1 25.9469 1 27.9359V31.9999H31V27.9359C31 25.9469 25.948 20.8519 16 20.8519Z\" fill=\"#434C5C\"/></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/svg/virtual-icons/person-full.svg
// module id = 1318
// module chunks = 0